module.exports = __webpack_public_path__ + "img/ASSEMBLY.31badff5.jpg";